import React, { useEffect, useState } from "react";
import styles from "./AcquaintedInformationForm.module.css";
import Header from "../../Header/Header";
import ProgressBar from "./ProgressBar";
import { useNavigate } from "react-router-dom";
import config from "../../../config";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { isValidPhoneNumber, validatePhoneNumber } from "../../../helpers/utils";
import PhoneInputField from "../../../components/PhoneInput/PhoneInput";
import { useProfile } from "../../../contexts/ProfileContext";
import { validateUSPhoneNumber, showErrorToast } from "../../utils";
const AcquaintedInformationForm = () => {
    const navigate = useNavigate();
    const { profileData: profile } = useProfile();

    // State variables to capture form input
    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
    });

    const [errors, setErrors] = useState({
        firstName: "",
        lastName: "",
    });

    useEffect(() => {
        setFormData((prev) => ({
            ...prev,
            firstName: profile?.first_name,
            lastName: profile?.last_name,
            email: profile?.email,
            phoneNumber: profile?.phone ? profile?.phone : "+1",
        }));
    }, [profile]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });

        // Validate input for numbers
        const hasNumbers = /\d/;
        if (hasNumbers.test(value)) {
            setErrors((prev) => ({
                ...prev,
                [name]: "Names cannot contain numbers.",
            }));
        } else {
            setErrors((prev) => ({
                ...prev,
                [name]: "",
            }));
        }
        if (name === "phoneNumber") {
            const digitsOnly = value.replace(/\D/g, "");

            // Format the number as (XXX) XXX-XXXX
            let formattedNumber = digitsOnly;
            if (digitsOnly.length > 3 && digitsOnly.length <= 6) {
                formattedNumber = `(${digitsOnly.slice(0, 3)}) ${digitsOnly.slice(3)}`;
            } else if (digitsOnly.length > 6) {
                formattedNumber = `(${digitsOnly.slice(0, 3)}) ${digitsOnly.slice(3, 6)}-${digitsOnly.slice(6, 10)}`;
            }

            // Validate length for a complete US number
            if (digitsOnly.length > 12) {
                setErrors((prev) => ({
                    ...prev,
                    [name]: "Phone number cannot exceed 12 digits.",
                }));
            } else if (digitsOnly.length < 10 && digitsOnly.length > 0) {
                setErrors((prev) => ({
                    ...prev,
                    [name]: "Phone number is incomplete.",
                }));
            } else {
                setErrors((prev) => ({
                    ...prev,
                    [name]: "",
                }));
            }
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault(); // Prevent the default form submission behavior
        console.log("🚀 ~ handleSubmit ~ formData.phoneNumber:", formData.phoneNumber);
        if (validateUSPhoneNumber(formData.phoneNumber)) {
            navigate("/get-title/Step-2", { state: formData });
        } else {
            showErrorToast("Please enter a valid US phone number.");
            return;
        }
    };

    useEffect(() => {
        document.title = `Title Services | ${config.get("COMPANY_NAME")}`;
    }, []);

    // const validateForm = () => {
    //     if (!firstName || !lastName || !phoneNumber || !email) {
    //         showErrorToast("Please fill in all fields.");
    //         return false;
    //     }
    //     // Email validation
    //     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    //     if (!emailRegex.test(email)) {
    //         showErrorToast("Please enter a valid email address.");
    //         return false;
    //     }

    //     return true; // If everything is valid
    // };

    return (
        <div className={`${styles.container} tw-bg-background_color`}>
            <main className={`${styles.mainContent} tw-bg-background_color  tw-items-center`}>
                <Header title="Title Services" />
                <section className={`${styles.formSection} tw-items-center tw-mt-[60px] tw-overflow-y-auto`}>
                    {/* <ProgressBar currentStep={1} totalSteps={3} /> */}
                    <div className={`${styles.formContainer} tw-w-full  max-lg:tw-w-[80%]`}>
                        <h1 className={styles.formTitle}>Let’s Get Started</h1>
                        <p className={styles.formDescription}>
                            Take the first step toward secure property rights. Share your details for personalized solutions and real-time updates
                            from our title service experts.
                        </p>
                        <form className={`${styles.generalForm}`} onSubmit={handleSubmit}>
                            <div className={styles.formRow}>
                                <div className={styles.fieldContainer}>
                                    <label className={styles.fieldLabel}>First Name</label>
                                    <input
                                        type="text"
                                        className={styles.fieldInput}
                                        placeholder="e.g. John"
                                        value={formData.firstName}
                                        name="firstName"
                                        required
                                        onChange={(e) => {
                                            // Allow only alphabets and spaces
                                            const regex = /^[A-Za-z\s]*$/;
                                            let value = e.target.value;

                                            if (regex.test(value)) {
                                                value = value.slice(0, 50); // limit to 50 chars
                                                setFormData((prev) => ({ ...prev, firstName: value }));
                                            }
                                        }}
                                    />
                                    {errors.firstName && <span style={{ color: "red" }}>{errors.firstName}</span>}
                                </div>

                                <div className={styles.fieldContainer}>
                                    <label className={styles.fieldLabel}>Last Name</label>
                                    <input
                                        type="text"
                                        className={styles.fieldInput}
                                        placeholder="e.g. Deol"
                                        value={formData.lastName}
                                        name="lastName"
                                        required
                                        onChange={(e) => {
                                            // Allow only alphabets and spaces
                                            const regex = /^[A-Za-z\s]*$/;
                                            let value = e.target.value;

                                            if (regex.test(value)) {
                                                value = value.slice(0, 50); // limit to 50 chars
                                                setFormData((prev) => ({ ...prev, lastName: value }));
                                            }
                                        }}
                                    />
                                    {errors.lastName && <span style={{ color: "red" }}>{errors.lastName}</span>}
                                </div>
                            </div>
                            <div className={styles.formRow}>
                                <div className={styles.fieldContainer}>
                                    <label className={styles.fieldLabel}>Phone Number</label>
                                    <PhoneInputField
                                        honeInputField
                                        phone={formData.phoneNumber}
                                        setPhone={(val) => setFormData((prev) => ({ ...prev, phoneNumber: val }))}
                                    />

                                    {errors.phoneNumber && <span style={{ color: "red" }}>{errors.phoneNumber}</span>}
                                </div>
                                <div className={styles.fieldContainer}>
                                    <label className={styles.fieldLabel}>Email Address</label>
                                    <input
                                        type="email"
                                        className={styles.fieldInput}
                                        placeholder="example@admin.com"
                                        value={formData.email}
                                        name="email"
                                        required
                                        onChange={handleInputChange}
                                    />
                                </div>
                            </div>
                            <p className="tw-text-secondary tw-italic tw-text-[12px] tw-text-justify">
                                Your privacy is our priority. We’ll never share your information without your explicit consent
                            </p>
                            {/* <div className={styles.formRow}>
                                <div className={styles.fieldContainer}>
                                    <label className={styles.fieldLabel}>Address</label>
                                    <input
                                        type="text"
                                        className={styles.fieldInput}
                                        placeholder="Enter your address"
                                        value={address}
                                        onChange={(e) => setAddress(e.target.value)}
                                    />
                                </div>
                                <div className={styles.fieldContainer}>
                                    <label className={styles.fieldLabel}>Unit Number</label>
                                    <input
                                        type="text"
                                        className={styles.fieldInput}
                                        placeholder="Enter your unit number"
                                        value={unitNumber}
                                        onChange={(e) => setUnitNumber(e.target.value)}
                                    />
                                </div>
                            </div> */}
                            <div className="tw-flex tw-justify-center">
                                <button
                                    type="submit"
                                    className={`${styles.submitButton} tw-w-fit tw-font-normal tw-bg-primary hover:tw-bg-primary_hover`}
                                >
                                    Next: Property Details
                                </button>
                            </div>
                        </form>
                    </div>
                </section>
            </main>
        </div>
    );
};

export default AcquaintedInformationForm;
